import axios from 'axios'
import { storage } from '@/utils/storage'
//年月日日期格式
export const yearMonthDate=()=>{
    var date = new Date();
    var ymd = date.getFullYear()+'/'+((date.getMonth()+1)<10?'0'+(date.getMonth()+1):(date.getMonth()+1))+'/'+(date.getDate()<10?'0'+date.getDate():date.getDate())
    return ymd
}
//时分秒格式
export const hourMinuteSecond=()=>{
    var date = new Date();
    var hms = (date.getHours()<10?'0'+date.getHours():date.getHours()) + ":"+(date.getMinutes()<10?'0'+date.getMinutes():date.getMinutes())+":"+(date.getSeconds()<10?'0'+date.getSeconds():date.getSeconds())
    return hms
}
//获取今日是星期几
export const weekFormat=()=>{
    var date = new Date();
    var day = date.getDay();
    var arr_week = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六");
    return arr_week[day]
}

/**
     * formatNumber()
     * 将数值四舍五入后格式化.
     *
     * @param num 数值(Number或者String)
     * @param cent 要保留的小数位(Number)
     * @param isThousand 是否需要千分位 0:不需要, 1:需要(数值类型);
     * @return 格式的字符串,如'1,234,567.45'
     * @type String
*/
export const formatNumber=(num, cent, isThousand)=>{
    num = num.toString().replace(/\$|\,/g, "");
    if (isNaN(num)) num = "0";
    var sign = num == (num = Math.abs(num));
    num = parseFloat(num.toFixed(cent));
    num = num.toString();
    var cents;
    if (num.lastIndexOf(".") != -1) {
        let index = num.lastIndexOf(".");
        cents = num.substring(index + 1, num.length);
    } else {
        cents = "";
    }
    num = Math.floor(num * Math.pow(10, cent) + 0.50000000001);
    num = Math.floor(num / Math.pow(10, cent)).toString();
    if (isThousand) {
        for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++)
        num = num.substring(0, num.length - (4 * i + 3)) + "," + num.substring(num.length - (4 * i + 3));
    }
    if (cent > 0) {
        if (cents == "") {
        return (sign ? "" : "-") + num;
        } else {
        return (sign ? "" : "-") + num + "." + cents;
        }
    } else {
        return (sign ? "" : "-") + num;
    }
}




// WEBPACK FOOTER //
// ./src/utils/tools.js